/**
 * Policies page: turns each <h2 id="..."> and the text under it into a
 * section that opens and closes on click. Links to #ordering, #returns etc.
 * (from anywhere on the site) open that section and scroll to it.
 */
(() => {
  const toc = document.querySelector('.page-content .saraj-policy-toc');
  const body = toc?.parentElement;
  if (!body) return;

  const icon =
    '<svg aria-hidden="true" viewBox="0 0 256 256" width="20" height="20" fill="currentColor"><path d="M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z"/></svg>';

  const sections = [];

  body.querySelectorAll(':scope > h2[id]').forEach((heading, index) => {
    const section = document.createElement('div');
    section.className = 'saraj-policy';

    const panel = document.createElement('div');
    panel.className = 'saraj-policy__panel';
    panel.id = `saraj-policy-panel-${index}`;
    const inner = document.createElement('div');
    inner.className = 'saraj-policy__inner';
    panel.append(inner);

    // Move everything up to the next section title into the panel
    let next = heading.nextElementSibling;
    while (next && next.tagName !== 'H2') {
      const current = next;
      next = next.nextElementSibling;
      inner.append(current);
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'saraj-policy__toggle';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', panel.id);
    button.innerHTML = `<span>${heading.innerHTML}</span><span class="saraj-policy__icon">${icon}</span>`;

    heading.classList.add('saraj-policy__heading');
    heading.replaceChildren(button);
    heading.before(section);
    section.append(heading, panel);

    button.addEventListener('click', () => toggle(section));
    sections.push(section);
  });

  if (!sections.length) return;
  body.classList.add('saraj-policies-ready');

  function toggle(section, open = !section.classList.contains('is-open')) {
    section.classList.toggle('is-open', open);
    section.querySelector('.saraj-policy__toggle').setAttribute('aria-expanded', String(open));
  }

  // Open the section named in the address (e.g. /pages/policies#returns)
  function openFromHash() {
    const id = decodeURIComponent(location.hash.slice(1));
    const heading = id && body.querySelector(`.saraj-policy__heading[id="${CSS.escape(id)}"]`);
    if (!heading) return;
    toggle(heading.parentElement, true);
    heading.scrollIntoView({ block: 'start' });
  }

  openFromHash();
  window.addEventListener('hashchange', openFromHash);
})();
